import createIcon from "components/elements/Icons/create-icon";

export default createIcon("ArrowRight", [
  [
    "path",
    {
      d: "M4.5 12C4.5 11.7238 4.72386 11.5 5 11.5H19C19.2762 11.5 19.5 11.7238 19.5 12C19.5 12.2762 19.2762 12.5 19 12.5H5C4.72386 12.5 4.5 12.2762 4.5 12Z",
    },
  ],
  [
    "path",
    {
      d: "M12.3536 4.64644L12.3535 4.64643C12.1583 4.45119 11.8417 4.45119 11.6465 4.64643L12.3536 4.64644ZM12.3536 4.64644L19.3536 11.6465C19.5488 11.8417 19.5488 12.1583 19.3536 12.3535L12.3536 19.3535C12.1583 19.5488 11.8417 19.5488 11.6465 19.3535C11.4512 19.1583 11.4512 18.8417 11.6465 18.6465L17.9394 12.3536L18.2929 12M12.3536 4.64644L18.2929 12M18.2929 12L17.9394 11.6464M18.2929 12L17.9394 11.6464M17.9394 11.6464L11.6465 5.35357M17.9394 11.6464L11.6465 5.35357M11.6465 5.35357C11.6465 5.35357 11.6465 5.35356 11.6465 5.35356M11.6465 5.35357L11.6465 5.35356M11.6465 5.35356C11.4512 5.15829 11.4512 4.8417 11.6465 4.64643L11.6465 5.35356Z",
    },
  ],
]);
